import React from 'react'

import { useParams } from 'react-router'

import { FrozenMealDishDetailsFragment, useOneFrozenMealDishQuery } from '@hooks/api'
import { CraftPizzaPDP, DetailPageWrapper } from '@organisms/index'
import { SearchEngineOptimization, SearchEngineOptimizationParams } from '@utility/SearchEngineOptimization'

const seo = (dish?: FrozenMealDishDetailsFragment): SearchEngineOptimizationParams => ({
  name: 'UCOOK Craft Pizza Dish',
  title: `${dish?.name ?? 'Awesome'} Recipe & Ingredients | UCOOK`,
  meta: [{
    name: 'description',
    content: `${dish?.description ?? 'Amazing Recipe'}`,
  }, {
    name: 'keywords',
    content: `${dish?.name ?? 'Awesome'} Recipe,${dish?.name ?? 'Awesome'} Ingredients,${dish?.name ?? 'Awesome'} delivery`,
  }, {
    name: 'robots',
    content: 'index,follow',
  }],
})

export function CraftPizzaDetails(): JSX.Element {

  const { slug } = useParams<{ slug: string }>()
  const { data, loading, error } = useOneFrozenMealDishQuery({ variables: { slug } })

  const dish = data?.dish

  return (
    <DetailPageWrapper
      loading={loading && !dish}
      error={error}
      pdp={<CraftPizzaPDP dish={dish} loading={loading} />}
      seo={<SearchEngineOptimization seo={seo(dish)} />} />
  )
}
